/**
 * @function - takes a list of stops and returns stops after
 * active stop with trip management etas
 * @param {object} stop
 */
export const filterConsequentStopsWithTripManagementEta = (stops = []) => {
  const nextStopIndex = stops?.findIndex((stop) => !stop.confirmed_arrival_at && !stop.confirmed_departure_at);
  return stops.filter((stop, stopIndex) => stopIndex > nextStopIndex && stop?.trip_management_eta);
};
